package one.healthium.cali.presentation.feature.today.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.produceState
import loco.CALI_GREETINGS_1
import loco.CALI_GREETINGS_10
import loco.CALI_GREETINGS_11
import loco.CALI_GREETINGS_2
import loco.CALI_GREETINGS_3
import loco.CALI_GREETINGS_4
import loco.CALI_GREETINGS_5
import loco.CALI_GREETINGS_6
import loco.CALI_GREETINGS_7
import loco.CALI_GREETINGS_8
import loco.CALI_GREETINGS_9
import one.healthium.base.preferences.AppPreferences
import one.healthium.base.utils.toLocalDate
import org.jetbrains.compose.resources.getString
import org.koin.compose.koinInject
import kotlin.time.Clock
import kotlin.time.Instant

private val greetings = listOf(
    loco.Res.string.CALI_GREETINGS_1,
    loco.Res.string.CALI_GREETINGS_2,
    loco.Res.string.CALI_GREETINGS_3,
    loco.Res.string.CALI_GREETINGS_4,
    loco.Res.string.CALI_GREETINGS_5,
    loco.Res.string.CALI_GREETINGS_6,
    loco.Res.string.CALI_GREETINGS_7,
    loco.Res.string.CALI_GREETINGS_8,
    loco.Res.string.CALI_GREETINGS_9,
    loco.Res.string.CALI_GREETINGS_10,
    loco.Res.string.CALI_GREETINGS_11,
)

@Composable
fun rememberGreetingText(): State<String> {
    val appPreferences = koinInject<AppPreferences>()
    val today = Clock.System.now().toLocalDate()

    return produceState("") {
        val lastGreetingText = appPreferences.greetingText
        val lastGreetingDate = appPreferences.greetingTimestamp?.let { Instant.fromEpochMilliseconds(it).toLocalDate() }

        if (lastGreetingText == null || lastGreetingDate != today) {
            val newGreetingText = getString(greetings.random())
            appPreferences.greetingText = newGreetingText
            appPreferences.greetingTimestamp = Clock.System.now().toEpochMilliseconds()
            newGreetingText
        } else {
            lastGreetingText
        }
    }
}